/**
 * Loading spinner shell used by ProtectedRoute, AdminRoute, and Login while
 * auth state hydrates. Variants differ only in container layout (route guards
 * paint a full-screen centered shell; Login paints an inline shell inside its
 * card).
 */

function Spinner() {
  return (
    <div className="w-8 h-8 border-2 border-[var(--gold)] border-t-transparent rounded-full animate-spin" />
  )
}

export default function AuthLoadingShell({ variant = 'route', message }) {
  if (variant === 'fullscreen') {
    return (
      <div className="min-h-screen bg-midnight flex items-center justify-center">
        <Spinner />
      </div>
    )
  }

  if (variant === 'inline') {
    return (
      <div className="max-w-md w-full flex flex-col items-center justify-center py-20">
        <div className="mb-4">
          <Spinner />
        </div>
        {message && <p className="text-[var(--text-muted)] text-sm">{message}</p>}
      </div>
    )
  }

  // variant === 'route' (default)
  return (
    <div className="flex items-center justify-center py-20">
      <Spinner />
    </div>
  )
}
